import { useEffect } from 'react';
import { ContentContainer } from 'app/components/Core';
import { ContentContainerType } from 'types/enums';
import { TuneCoreVersionAudioFormProps } from './types';
import { useTuneCoreVersionAudio } from './hooks';
import { TuneCoreVersionAudioForm } from './TuneCoreVersionAudioForm';

export const TuneCoreVersionAudioComponent = (
  props: TuneCoreVersionAudioFormProps
) => {
  const {
    primaryAudio,
    fetchAudioDetailsValidations,
    updateAudioValidations,
  } = props;
  const formProps = useTuneCoreVersionAudio(props);

  useEffect(() => {
    if (!updateAudioValidations && primaryAudio?.audioData.guid) {
      fetchAudioDetailsValidations(primaryAudio.audioData.guid);
    }
  }, [updateAudioValidations, primaryAudio, fetchAudioDetailsValidations]);

  return (
    <ContentContainer type={ContentContainerType.LIST} pb={24}>
      <TuneCoreVersionAudioForm {...formProps} />
    </ContentContainer>
  );
};
